import type { FC } from "react";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import type { TranslationKey } from "@privacy/translations";
import { useTranslation } from "@privacy/translations";
import type { Theme } from "@mui/material/styles";

export type Colors = {
  border: (theme: Theme) => string;
  background: (theme: Theme) => string;
  text: (theme: Theme) => string;
};

type StatusChipProps = { colors: Colors; labelKey: TranslationKey };

export const StatusChip: FC<StatusChipProps> = ({ colors, labelKey }) => {
  const { t } = useTranslation();
  return (
    <Stack
      direction="row"
      spacing={1}
      sx={{
        mixBlendMode: "multiply",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: colors.background,
        borderRadius: 2,
        border: "1px solid",
        borderColor: colors.border,
        py: "2px",
        px: 1.5,
        width: "fit-content",
        height: "18px",
      }}
    >
      <Typography
        data-testid="statusChip"
        sx={{ fontWeight: "600", fontSize: theme => theme.typography.pxToRem(12), color: colors.text }}
      >
        {t(labelKey)}
      </Typography>
    </Stack>
  );
};
